import React, { useEffect, useState } from "react";
import { Box, IconButton } from "@mui/material";
import { Delete } from "@mui/icons-material";
import TransitionsModal from "../components/Modal";
import { BeatLoader } from "react-spinners";
import { toast } from "react-toastify";
import { Icon } from "@iconify/react";
import {
  deleteApi,
  getApi,
  postApi,
  putFormDataApi,
} from "../config/configAxios";
import Swal from "sweetalert2";
import CustomLoader from "../components/CustomLoader";
import AdminLayout from "../layouts/adminLayout/AdminLayout";
import JoditEditor from "jodit-react";
import { config } from "../utils/JoditConfig";

const LifeStruggle = () => {
  const [data, setData] = useState([]);
  const [storeData, setStoreData] = useState({});
  const [editData, setEditData] = useState({});
  const [loading, setLoading] = useState(true);
  const [openStore, setOpenStore] = useState(false);
  const [openEdit, setOpenEdit] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const fetchData = async () => {
    try {
      const res = await getApi("life-struggle");
      setData(res.data.data);
    } catch (err) {
      toast.error(err?.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    setStoreData((prevData) => ({ ...prevData, file }));
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setStoreData((prevData) => ({ ...prevData, [name]: value }));
  };

  const handleStore = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);

    const formData = new FormData();
    formData.append("content_en", storeData.content_en);
    formData.append("content_bn", storeData.content_bn);
    formData.append("title_en", storeData.title_en);
    formData.append("title_bn", storeData.title_bn);
    formData.append("file", storeData.file);

    try {
      await postApi("life-struggle", formData);
      setOpenStore(false);
      setStoreData({});
      fetchData();
      toast.success("Data created successfully!");
    } catch (err) {
      toast.error(err?.response?.data?.error || "Update failed");
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleDelete = async (id) => {
    Swal.fire({
      title: "Confirm delete",
      text: "Are you sure you want to delete this?",
      icon: "question",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          try {
            await deleteApi(`life-struggle/${id}`)
              .then(() => {
                toast.success("Data deleted successfully!");
              })
              .catch(() => {
                toast.error("An error occurred while updating status");
              })
              .finally(() => {
                fetchData();
              });
          } catch (err) {
            toast.error(err?.response?.data?.error || "Update failed");
          }
        } catch (error) {
          Swal.fire(
            "Error",
            "An error occurred while delete the data.",
            "error"
          );
        }
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        Swal.fire("Cancelled", "The data was not deleted.", "info");
      }
    });
  };

  const handleEdit = async (id) => {
    setOpenEdit(true);
    try {
      const res = await getApi(`life-struggle/${id}`);
      setEditData(res.data);
      setStoreData(res.data);
    } catch (err) {
      toast.error(err?.message);
    }
  };

  const handleUpdate = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);

    const formData = new FormData();
    formData.append("id", editData.id);
    formData.append("content_en", storeData.content_en);
    formData.append("content_bn", storeData.content_bn);
    formData.append("title_en", storeData.title_en);
    formData.append("title_bn", storeData.title_bn);
    formData.append("file", storeData.file);

    try {
      await putFormDataApi("life-struggle", formData);
      setOpenEdit(false);
      setEditData({});
      setStoreData({});
      fetchData();
      toast.success("Data updated successfully!");
    } catch (err) {
      toast.error(err?.response?.data?.error || "Update failed");
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <AdminLayout title={"History of Life and Struggle"}>
      {loading ? (
        <CustomLoader />
      ) : (
        <div>
          <div className="flex justify-between p-3">
            <h1 className="text-gray-700 font-medium">
              History of Life and Struggle list
            </h1>
            <div>
              <button className="btn-indigo" onClick={() => setOpenStore(true)}>
                Add new
              </button>
            </div>
          </div>
          <div className="table-wrap">
            <table className="table-main shadow-md">
              <thead className="table-h">
                <tr>
                  <th className="table-h">SN</th>
                  <th className="table-h">Title EN</th>
                  <th className="table-h">Photo</th>
                  <th className="table-h">Action</th>
                </tr>
              </thead>
              <tbody className="table-b">
                {data &&
                  data.length > 0 &&
                  data.map((item, index) => (
                    <tr key={item.id}>
                      <td className="table-b">{index + 1}</td>
                      <td className="table-b">{item.title_en}</td>
                      <td className="table-b">
                        <img
                          className="h-10 rounded-lg"
                          src={`${process.env.REACT_APP_API_FILE_URL}${item.file}`}
                          alt=""
                        />
                      </td>

                      <td className="table-b">
                        <Box display="flex">
                          <IconButton
                            className="mr-3"
                            onClick={() => handleDelete(item.id)}
                          >
                            <Delete className="text-red-500" />
                          </IconButton>
                          <IconButton
                            className="mr-3"
                            onClick={() => handleEdit(item.id)}
                          >
                            <Icon icon={"bxs:edit"} className="text-blue-500" />
                          </IconButton>
                        </Box>
                      </td>
                    </tr>
                  ))}
              </tbody>
            </table>
          </div>
        </div>
      )}

      <TransitionsModal title={"Add"} open={openStore} setOpen={setOpenStore}>
        <form onSubmit={handleStore}>
          <div className="grid grid-cols-1 gap-6 md:grid-cols-2">
            <div>
              <label htmlFor="title_en" className="font-semibold text-sm">
                Title EN
              </label>
              <input
                type="text"
                id="title_en"
                name="title_en"
                onChange={handleInputChange}
                placeholder="title_en"
                className="form-control"
                required
              />
            </div>
            <div>
              <label htmlFor="title_bn" className="font-semibold text-sm">
                Title BN
              </label>
              <input
                type="text"
                id="title_bn"
                name="title_bn"
                onChange={handleInputChange}
                placeholder="title_bn"
                className="form-control"
                required
              />
            </div>
            <div>
              <label htmlFor="file" className="font-semibold text-sm">
                Logo
              </label>
              <input
                type="file"
                id="file"
                name="file"
                onChange={handleFileChange}
                placeholder="Upload file"
                className="form-control"
              />
            </div>
            <div className="flex gap-2">
              {storeData?.file && typeof storeData?.file !== "string" && (
                <>
                  <label htmlFor="file" className="font-semibold text-sm">
                    New Photo
                  </label>
                  <img
                    className="h-20 rounded-md border border-dashed p-3"
                    src={URL.createObjectURL(storeData.file)}
                    alt="Preview"
                  />
                </>
              )}
            </div>

            <div className="md:col-span-1">
              <label htmlFor="content_en" className="font-semibold text-sm">
                Content EN
              </label>
              <JoditEditor
                config={config}
                tabIndex={1}
                value={storeData?.content_en}
                onBlur={(newContent) =>
                  setStoreData((prevData) => ({
                    ...prevData,
                    content_en: newContent,
                  }))
                }
              />
            </div>
            <div className="md:col-span-1">
              <label htmlFor="content_bn" className="font-semibold text-sm">
                Content BN
              </label>
              <JoditEditor
                config={config}
                tabIndex={1}
                value={storeData?.content_bn}
                onBlur={(newContent) =>
                  setStoreData((prevData) => ({
                    ...prevData,
                    content_bn: newContent,
                  }))
                }
              />
            </div>

            <div className="md:col-span-2">
              <button
                disabled={isSubmitting}
                type="submit"
                className="btn-green w-full"
                data-ripple-light="true"
              >
                {isSubmitting ? <BeatLoader color="#fff" /> : "Save"}
              </button>
            </div>
          </div>
        </form>
      </TransitionsModal>

      <TransitionsModal title={"Edit"} open={openEdit} setOpen={setOpenEdit}>
        <form onSubmit={handleUpdate}>
          <div className="grid grid-cols-1 gap-6 md:grid-cols-2">
            <div>
              <label htmlFor="title_en" className="font-semibold text-sm">
                Title EN
              </label>
              <input
                type="text"
                id="title_en"
                name="title_en"
                value={storeData?.title_en || ""}
                onChange={handleInputChange}
                placeholder="title_en"
                className="form-control"
                required
              />
            </div>
            <div>
              <label htmlFor="title_bn" className="font-semibold text-sm">
                Title BN
              </label>
              <input
                type="text"
                id="title_bn"
                name="title_bn"
                value={storeData?.title_bn || ""}
                onChange={handleInputChange}
                placeholder="title_bn"
                className="form-control"
                required
              />
            </div>
            <div>
              <label htmlFor="file" className="font-semibold text-sm">
                Logo
              </label>
              <input
                type="file"
                id="file"
                name="file"
                onChange={handleFileChange}
                placeholder="Upload file"
                className="form-control"
              />
            </div>
            <div className="flex gap-2">
              <div>
                <label htmlFor="file" className="font-semibold text-sm">
                  Logo
                </label>
                <img
                  className="h-20 rounded-md border border-dashed p-3"
                  src={`${process.env.REACT_APP_API_FILE_URL}${editData?.file}`}
                  alt=""
                />
              </div>
              <div>
                {storeData?.file && typeof storeData?.file !== "string" && (
                  <>
                    <label htmlFor="file" className="font-semibold text-sm">
                      New image
                    </label>
                    <img
                      className="h-20 rounded-md border border-dashed p-3"
                      src={URL.createObjectURL(storeData.file)}
                      alt="Preview"
                    />
                  </>
                )}
              </div>
            </div>

            <div className="md:col-span-1">
              <label htmlFor="content_en" className="font-semibold text-sm">
                Content EN
              </label>
              <JoditEditor
                config={config}
                tabIndex={1}
                value={storeData?.content_en}
                onBlur={(newContent) =>
                  setStoreData((prevData) => ({
                    ...prevData,
                    content_en: newContent,
                  }))
                }
              />
            </div>
            <div className="md:col-span-1">
              <label htmlFor="content_bn" className="font-semibold text-sm">
                Content BN
              </label>
              <JoditEditor
                config={config}
                tabIndex={1}
                value={storeData?.content_bn}
                onBlur={(newContent) =>
                  setStoreData((prevData) => ({
                    ...prevData,
                    content_bn: newContent,
                  }))
                }
              />
            </div>

            <div className="md:col-span-2">
              <button
                disabled={isSubmitting}
                type="submit"
                className="btn-green w-full"
                data-ripple-light="true"
              >
                {isSubmitting ? <BeatLoader color="#fff" /> : "Update"}
              </button>
            </div>
          </div>
        </form>
      </TransitionsModal>
    </AdminLayout>
  );
};

export default LifeStruggle;
